export default __webpack_public_path__ + "static/media/intentions2.a7415d7c.png";